import { lightColors, darkColors } from "@certn/cascadia-tokens";

import { useColorScheme } from "./useColorScheme";
import { useTheme } from "../../cascadia";

export function useScheme() {
  const { theme = "system" } = useTheme();
  const systemTheme = useColorScheme() || "light";
  const scheme = theme === "system" ? systemTheme : theme;
  return scheme;
}

export function useColors() {
  const scheme = useScheme();

  return scheme === "light" ? lightColors : darkColors;
}
